import { Pipe, PipeTransform } from '@angular/core';
import { ProjectLanguage } from '../../firestore-models/project-language';

@Pipe({
  name: 'multiMailTitle',
  standalone: false,
})
export class MultiMailTitlePipe implements PipeTransform {

  transform(values: Array<{lang_code: string, mail_title: string}>, languages: Array<ProjectLanguage>,currentLang: string = 'ja'): string {
    let mail_title: string = '';
    if (!!values) {
      // const language = languages[0];
      const language = languages.find(lang => lang.lang_code === currentLang);//#216 日本語固定になっているので、admin_lang_modeに従って出し分ける
      if (language) {
        for (const value of values) {
          if (language.lang_code === value.lang_code) {
            mail_title = value.mail_title;
            break;
          }
        }
      }
    }
    return mail_title;
  }

}
